module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-pagination', {
    attrs: {
      "background": "",
      "current-page": _vm.cPage,
      "page-size": _vm.pageSize,
      "layout": "prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange,
      "update:currentPage": function($event) {
        _vm.cPage = $event
      },
      "update:current-page": function($event) {
        _vm.cPage = $event
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@9.9.5@vue-loader/lib/template-compiler.js?id=data-v-0471ae3e!./~/_vue-loader@9.9.5@vue-loader/lib/selector.js?type=template&index=0!./src/components/common/Page.vue
// module id = 291
// module chunks = 0